var render = function render(){var _vm=this,_c=_vm._self._c;return _c('moderator-detail',{attrs:{"moderator":_vm.moderator}})
}
var staticRenderFns = []

export { render, staticRenderFns }